import { Component, Input, Renderer, ViewChild } from '@angular/core';
/**
 * https://github.com/samarthagarwal/ionic-accordion-component
 */
var HTML_TEMPLATE = "\n<ion-card>\n  <ion-card-header class=\"accordion-title\" (click)=\"toggle()\" no-padding>\n    <ion-item color=\"primary\" text-wrap>\n      <button ion-button clear small icon-only item-right>\n        <ion-icon color=\"light\" [name]=\"icon\"></ion-icon>\n      </button>\n      {{ title }}\n    </ion-item>\n  </ion-card-header>\n  <ion-card-content class=\"accordion-content\" #cc no-padding>\n    <ng-content></ng-content>\n  </ion-card-content>\n</ion-card>\n";
var CSS_STYLE = "\naccordion {\n  .card-header {\n    background-color: map-get($colors, primary);\n    color: #fff;\n  }\n\n  .card-content {\n    padding: 0px;\n    max-height: 0px;\n  }\n\n  .ion-item {\n    padding: 0px 16px;\n  }\n}\n";
var AccordionComponent = (function () {
    function AccordionComponent(renderer) {
        this.renderer = renderer;
        this.exapanded = false;
        this.icon = "arrow-forward";
    }
    AccordionComponent.prototype.ngOnInit = function () {
        this.renderer.setElementStyle(this.cardContent.nativeElement, "webkitTransition", "max-height 300ms");
        this.renderer.setElementStyle(this.cardContent.nativeElement, "max-height", "0px");
    };
    AccordionComponent.prototype.toggle = function () {
        this.renderer.setElementStyle(this.cardContent.nativeElement, "max-height", (this.exapanded) ? "0px" : "500px");
        this.exapanded = !this.exapanded;
        this.icon = this.icon == "arrow-forward" ? "arrow-down" : "arrow-forward";
    };
    AccordionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'accordion',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    AccordionComponent.ctorParameters = function () { return [
        { type: Renderer, },
    ]; };
    AccordionComponent.propDecorators = {
        "cardContent": [{ type: ViewChild, args: ["cc",] },],
        "title": [{ type: Input, args: ['title',] },],
    };
    return AccordionComponent;
}());
export { AccordionComponent };
//# sourceMappingURL=accordion.js.map


//////////////////
// WEBPACK FOOTER
// ../ionic-commons/dist/components/accordion.js
// module id = 386
// module chunks = 0